var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArticleMedium = function SvgIconArticleMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5.5h-.5a1 1 0 1 1 0-2h1.487a1 1 0 0 1 .87.485L7.5 8.613l2.893-4.628a1 1 0 0 1 .266-.291c.174-.128.386-.197.604-.194h1.487a1 1 0 1 1 0 2h-.5V11h.5a1 1 0 1 1 0 2H10.5a1 1 0 0 1-.25-1.968V7.987L8.348 11.03a1 1 0 0 1-1.696 0L4.75 7.987v3.045A1 1 0 0 1 4.5 13H2.25a1 1 0 1 1 0-2h.5zM16.5 7.25a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zM15.5 12a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1M6.75 14.75a1 1 0 1 0 0 2H22.5a1 1 0 1 0 0-2zM5.75 19.5a1 1 0 0 1 1-1H22.5a1 1 0 1 1 0 2H6.75a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconArticleMedium;